import VendorUtil from '@utils/vendorUtils';

// const BASE_API_URL = process.env.NEXT_PUBLIC_API_URL;
const BASE_API_URL = VendorUtil.generateApiUrl(process.env.NEXT_PUBLIC_API_URL || '');
const BASE_API_URL_SERVER_SIDE = process.env.NEXT_PUBLIC_API_URL_SERVER_SIDE || '';

const NATS_API_URL = process.env.NEXT_PUBLIC_NATS_API_URL;
const NATS_SUBSCRIBE_TITLE = process.env.NEXT_PUBLIC_NATS_SUBSCRIBE_TITLE;
const NEXT_PUBLIC_NATS_HEALTH_URL = process.env.NEXT_PUBLIC_NATS_HEALTH_CHECK;
const SIGNALR_API_URL = process.env.NEXT_PUBLIC_SIGNALR_API_URL;
const REPORT_API_URL = process.env.NEXT_PUBLIC_REPORT_API_URL;
const BIKER_API_URL = process.env.NEXT_PUBLIC_BIKER_APP;
export {
  BASE_API_URL,
  REPORT_API_URL,
  SIGNALR_API_URL,
  BIKER_API_URL,
  NATS_API_URL,
  NATS_SUBSCRIBE_TITLE,
  NEXT_PUBLIC_NATS_HEALTH_URL,
  BASE_API_URL_SERVER_SIDE,
};
